import { get } from 'lodash'
import { required, email } from 'utils/validation'

export default function(values = {}, props) {
  let errors = {
    email: required(values.email) || email(values.email)
  }

  if (!get(props, 'permissions.isLeader')) {
    errors = {
      ...errors,
      organizationId: required(values.organizationId)
    }
  }

  return errors
}
